import React, {FC} from "react";
import {ExternalChatChannel, ExternalChatUserStatus} from "domain-entities";
import {Box, makeStyles} from "@material-ui/core";
import {DocumentsOnceStore} from "Helpers/StoreHelper";
import {px} from "Configs/theme";
import FadeInBox from "../Layout/FadeInBox";
import {useTranslation} from "../../Providers/TranslationProvider";

enum ChannelTypeColor {
  GREEN = "#5BB000",
  YELLOW = "#F7B500",
  RED = "#DC0E0E",
}

interface Props {
  channel: ExternalChatChannel;
  userStatusesOnceStore: DocumentsOnceStore<ExternalChatUserStatus>;
}

const ChannelTypeView: FC<Props> = (props) => {
  const classes = useStyles();
  const {t} = useTranslation();

  if (props.userStatusesOnceStore.isLoading) {
    return null;
  } else {
    const channelUserStatusTypes = props.userStatusesOnceStore.items
        .filter((userStatus) =>
            props.channel.usersActive.includes(userStatus.userId)
        )
        .map((userStatus) => userStatus.type);

    let statusText = channelUserStatusTypes.includes("online")
        ? t("ChannelsView_ChatStatus_Online")
        : channelUserStatusTypes.includes("idle")
            ? t("ChannelsView_ChatStatus_Idle")
            : t("ChannelsView_ChatStatus_Offline");

    let color = channelUserStatusTypes.includes("online")
        ? ChannelTypeColor.GREEN
        : channelUserStatusTypes.includes("idle")
            ? ChannelTypeColor.YELLOW
            : ChannelTypeColor.RED;

    return (
        <FadeInBox className={classes.root}>
          <Box style={{backgroundColor: color}} className={classes.statusDot}/>
          <Box className={classes.status} style={{color}}>{statusText}</Box>
        </FadeInBox>
    );
  }
};

export default ChannelTypeView;

const useStyles = makeStyles({
  root: {
    display: "flex",
    flex: 1,
    alignItems: "center"
  },
  statusDot: {
    width: px.m,
    height: px.m,
    borderRadius: "100%",
    marginRight: px.s,
  },
  status: {
    fontSize: px.m,
    lineHeight: px.xl
  }
});
